import { Modal } from '@mantine/core';
import Link from 'next/link';
import type { FC } from 'react';
import { Button, Chip } from '@/DesignSystem/Component';
import { setLoginModalIsOpen } from '@/Module/Auth/Store/Slice/AuthSlice';
import { useOTP } from '@/Module/Comment/Hook/useOTP';
import { LINKS } from '@/Module/Core/Constant';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
import AuthConfirmForm from '../AuthConfirmForm/AuthConfirmForm';
import AuthLoginForm from '../AuthForm/AuthLoginForm';
const ModalLogin: FC = () => {
  const dispatch = useAppDispatch();
  const loginModalIsOpen = useAppSelector(state => state.auth.loginModalIsOpen);
  const {
    showConfirm,
    setShowConfirmOTP
  } = useOTP();
  const onCLose = () => {
    dispatch(setLoginModalIsOpen(false));
  };
  return <Modal onClose={onCLose}
  // dismissible
  opened={loginModalIsOpen} size="md" centered radius={0} overlayProps={{
    className: '',
    style: {
      backdropFilter: '#0e4791'
    },
    backgroundOpacity: 0.35,
    blur: 9
  }} withCloseButton={false} classNames={{
    root: 'bg-[rgba(14, 71, 145, 0.25)] ',
    content: 'shadow-theme shadow-blueFive bg-blueOne border-4 border-blueFive px-6 py-6'
  }} data-sentry-element="Modal" data-sentry-component="ModalLogin" data-sentry-source-file="ModalLogin.tsx">
      <div className="flex-1">
        <Chip title="ورود به مدرسه" color="primary" className="mb-7" data-sentry-element="Chip" data-sentry-source-file="ModalLogin.tsx" />
        {showConfirm ? <AuthConfirmForm isModal setShowConfirmOTP={setShowConfirmOTP} /> : <AuthLoginForm isModal setShowConfirmOTP={setShowConfirmOTP} />}
      </div>
      <div className="mt-4 flex items-center justify-center gap-1 text-[12px]  text-blueFive  lg:text-lg">
        ورود شما به معنای پذیرش{' '}
        <Button as={Link} href={LINKS.RULES} variant="text" color="primary" size="small" target="_blank" bold data-sentry-element="Button" data-sentry-source-file="ModalLogin.tsx">
          قوانین آی‌نو
        </Button>{' '}
        است.
      </div>
    </Modal>;
};
export default ModalLogin;